import { render, staticRenderFns } from "./wdhdyy_details.vue?vue&type=template&id=cc128492&scoped=true&"
import script from "./wdhdyy_details.vue?vue&type=script&lang=js&"
export * from "./wdhdyy_details.vue?vue&type=script&lang=js&"
import style0 from "./wdhdyy_details.vue?vue&type=style&index=0&id=cc128492&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc128492",
  null
  
)

export default component.exports